<template>
<div class="doc-bg">
  <img class="head" :src="docinfo.avatar">
  <p>{{docinfo.zname}}</p>
  <span>{{docinfo.position}}</span>
  <img class="slg" src="../../../static/icons/qrcodeslg.png" alt="">
  <img class="code" :src="docinfo.qrcode">
</div>
</template>

<script>

    import http from "../../request/http";

    export default {
        name: "doctorCode",
        data(){
          return {
            docinfo:{}
          }
        },
        mounted() {
          this.getDoc();
        },
        methods:{
          getDoc(){
            let docid = this.$route.query.docid;
            http.post('/api/wap/public/share',{
              doctorId:docid
            }).then(res=>{
              console.log(res)
              this.docinfo = res.data[0];
            })
          }
        }
    }
</script>

<style scoped>
.doc-bg{
  background: #f9f9f9;
  width: 100%;
  height: 100vh;
  text-align: center;
  padding-top: 4rem;
}
.head{
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  margin-bottom: 0.5rem;
}
.doc-bg p{
  font-weight: 700;
  font-size: 1rem;
}
.doc-bg span{
  font-size: 0.8rem;
  color: #666;
}
.doc-bg img{
  max-width: 100%;
}
  .slg{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  .code{
    width: 6rem;
    height:6rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/doctorCode/doctorCode.vue